import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { login } from './actions';
import { Row, Col, Spin, Card } from 'antd';
import { Button, Input } from '../../components';
import { Link, useNavigate } from 'react-router-dom';
import { Strings } from '../../utils/strings';

import axios from 'axios';

const Login = () => {
  const [email, setEmail] = React.useState('');
  const [password, setPassword] = React.useState('');
  const [stores, setStores] = useState([]);
  const loading = useSelector((s) => s.auth.user.loading);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const loginFunc = React.useCallback(() => {
    dispatch(login({ email, password, navigate }));
  }, [email, password]);

  useEffect(() => {
    fetchStores();
  }, []);

  const fetchStores = () => {
    let config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: 'http://piaxu.com/wp-json/dokan/v1/stores',
      headers: {
        Authorization:
          'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOi8vcGlheHUuY29tIiwiaWF0IjoxNjg5ODUxOTE0LCJuYmYiOjE2ODk4NTE5MTQsImV4cCI6MTY5MDQ1NjcxNCwiZGF0YSI6eyJ1c2VyIjp7ImlkIjoiMSJ9fX0.YxQbFdZlxOrAQduQa0Nv1fIYUqGT8AkcWCiXjWnDXKk',
      },
    };
    axios
      .get('http://piaxu.com//wp-json/dokan/v1/stores', {}, config)
      .then((response) => {
        console.log(response.data);
        setStores(response.data);
      })
      .catch((error) => console.log(error));
  };

  useEffect(() => {
    console.log('store updated', stores);
  }, [stores]);

  return (
    <>
      <Row style={{ height: window.innerHeight }} className="loginContainer">
        <Col md={12}>
          <div>
            <div className="left">
              <img
                src={require('../../images/logo.png')}
                style={{ width: '200px' }}
                alt=""
                className="logo"
              />
              <h2>Sign In</h2>
              <Input placeholder="Email" value={email} onChange={setEmail} />
              <Input
                placeholder="Password"
                value={password}
                onChange={setPassword}
                type="password"
              />
              <Button
                title="Sign In"
                block
                onClick={loginFunc}
                loading={loading}
              />
              <p>
                Don't have an account? <Link to="/signup">Sign Up</Link>
              </p>
              <p>
                Forgot your password? <Link to="/reset-password">Reset</Link>
              </p>
            </div>
          </div>
        </Col>
        <Col md={12}>
          <div
            className="right"
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignContent: 'center',
              alignItems: 'center',
            }}
          >
            <Row align={'middle'}>
              <img
                //  src={require("../../images/login.svg").default}
                src={require('../../images/login.png')}
                alt=""
                style={{ width: '100%' }}
              />
            </Row>
            <Row className="loginPromoRow">
              <span className="loginPromoText">{Strings.Login.promoText}</span>
              {Strings.Login.subText}
            </Row>
          </div>
        </Col>
      </Row>

      {/*---stores--> */}

      <div style={{ backgroundColor: '#d1d1d1', padding: '40px 80px' }}>
        <Row>
          <Col>
            <h1 align="center">Stores</h1>
            <br />
          </Col>
        </Row>
        <Spin spinning={stores.length < 1}>
          <Row
            gutter={[16, 16]}
            style={{ overflow: 'scroll' }}
            justify={{ xs: 1 }}
          >
            {!!stores
              ? stores.map((item) => (
                  <Col span={4} key={item.id + item.name?.toString()}>
                    <Card
                      title={item.store_name || 'UNNAMED STORE'}
                      bordered={false}
                    >
                      <img
                        src={item.gravatar}
                        style={{ height: 100, width: 'auto' }}
                      />
                      <br />
                      <b>
                        {item.first_name || 'UNNAMED' + ' ' + item.last_name}
                      </b>
                      <br />
                      Phone: {item.phone || 'N/A'}
                      <br />
                      Rating: {item.rating.rating}
                      <br />
                      <br />
                      <a href={item.shop_url} target="_blank">
                        <Button>Visit Shop</Button>
                      </a>
                    </Card>
                  </Col>
                ))
              : 'Loading'}
          </Row>
        </Spin>
      </div>
    </>
  );
};

export default Login;
